export const getNameInitials = (name: string) => {
  try {
    if (!name || name === '' || !name.trim()) {
      return ''
    }
    const normalizeText = name.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    const splittedName = normalizeText.split(' ')
    const cleanArray = splittedName.filter((item) => item)
    const firstName = cleanArray[0]?.toUpperCase()
    const lastName = cleanArray[cleanArray.length - 1]?.toUpperCase()
    return `${firstName[0]}${
      cleanArray.length > 1 ? lastName[0] : firstName[1]
    }`
  } catch (err) {
    return ''
  }
}
